module.exports = __webpack_public_path__ + "assets/img/68@3x.b2b01979.png";